const c = {
  name: "PosTalk",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 40" style="enable-background:new 0 0 26 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.3,1.2-1.3C13.7,9.8,14.3,10.3,14.3,11z"
			/>
		<path class="st0" d="M9,12.3c0.7,0,1.3-0.6,1.3-1.2c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.2,0.6-1.2,1.3C7.8,11.7,8.3,12.3,9,12.3z"/>
		<path class="st0" d="M11,4c-3.9,0-7,3.1-7,7c0,1.1,0.3,2.1,0.7,3.1l-1.1,4.3l4.3-1.1c0.9,0.5,2,0.7,3.1,0.7c3.9,0,7-3.1,7-7
			S14.9,4,11,4z M6,11c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5c0,2.8-2.2,5-5,5c-0.9,0-1.7-0.2-2.4-0.6l-0.3-0.2l-1.8,0.5l0.5-1.8l-0.2-0.3
			C6.2,12.7,6,11.9,6,11z"/>
		<path class="st0" d="M7,27.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2S5.8,25.3,5.8,26C5.8,26.7,6.3,27.3,7,27.3z"/>
		<path class="st0" d="M12.3,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2c0-0.7,0.6-1.2,1.3-1.2C11.7,24.8,12.3,25.3,12.3,26z"
			/>
		<path class="st0" d="M15,27.3c0.7,0,1.3-0.6,1.3-1.2c0-0.7-0.6-1.2-1.3-1.2c-0.7,0-1.2,0.6-1.2,1.2C13.8,26.7,14.3,27.3,15,27.3z"
			/>
		<path class="st0" d="M8.3,30c0,0.7-0.6,1.2-1.2,1.2S5.8,30.7,5.8,30c0-0.7,0.6-1.2,1.2-1.2S8.3,29.3,8.3,30z"/>
		<path class="st0" d="M11,31.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C9.8,30.7,10.3,31.3,11,31.3z"
			/>
		<path class="st0" d="M16.3,30c0,0.7-0.6,1.2-1.3,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C15.7,28.8,16.3,29.3,16.3,30z"
			/>
		<path class="st0" d="M7,35.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2S5.8,33.3,5.8,34C5.8,34.7,6.3,35.3,7,35.3z"/>
		<path class="st0" d="M12.3,34c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2c0-0.7,0.6-1.2,1.3-1.2C11.7,32.8,12.3,33.3,12.3,34z"
			/>
		<path class="st0" d="M15,35.3c0.7,0,1.3-0.6,1.3-1.2c0-0.7-0.6-1.2-1.3-1.2c-0.7,0-1.2,0.6-1.2,1.2C13.8,34.7,14.3,35.3,15,35.3z"
			/>
		<path class="st0" d="M0,3c0-1.7,1.3-3,3-3h16c1.7,0,3,1.3,3,3v34c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3z M3,2C2.5,2,2,2.5,2,3v17
			h18V3c0-0.5-0.5-1-1-1H3z M20,22H2v15c0,0.5,0.5,1,1,1h16c0.5,0,1-0.5,1-1V22z"/>
		<path class="st0" d="M24,22V2h2v20H24z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as PosTalk
};
